/* eslint-disable */

const addImpact = () => {
  if (process.env.NODE_ENV !== 'production') return;

  (function (a, b, c, d, e, f, g) {
    e['ire_o'] = c;
    e[c] =
      e[c] ||
      function () {
        (e[c].a = e[c].a || []).push(arguments);
      };
    f = d.createElement(b);
    g = d.getElementsByTagName(b)[0];
    f.async = 1;
    f.src = a;
    g.parentNode.insertBefore(f, g);
  })(
    'https://d.impactradius-event.com/A2583283-05c6-45e1-ba2d-2002576c81fa1.js',
    'script',
    'ire',
    document,
    window
  );

  ire('identify', { customerEmail: '', customerId: '' });
};

export default addImpact;
